import { ReactElement } from "react";
import { t } from "@lingui/core/macro";

import * as S from "./styled";

type NumberBadgeProps = {
  number: number;
  size?: "sm" | "md" | "lg";
  className?: string;
};

export const NumberBadge = ({
  number,
  size,
  className,
}: NumberBadgeProps): ReactElement => (
  <S.NumberBadge
    $size={size}
    className={className}
    title={t`common.revision-name ${number}`}
  >
    #{number}
  </S.NumberBadge>
);
